import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { QuoteProvider } from "@/context/QuoteContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import QuoteDialog from "@/components/QuoteDialog";
import WhatsAppFab from "@/components/WhatsAppFab";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Servizi from "@/pages/Servizi";
import Progetti from "@/pages/Progetti";
import Contatti from "@/pages/Contatti";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import ManutenzionePoligoni from "@/pages/ManutenzionePoligoni";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";
import CookieBanner from "@/components/CookieBanner";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App noise-overlay min-h-screen bg-ink text-white">
      <BrowserRouter>
        <QuoteProvider>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/progetti" element={<Progetti />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/manutenzione-poligoni-di-tiro" element={<ManutenzionePoligoni />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:slug" element={<ProductDetail />} />
            <Route path="/privacy-policy" element={<LegalPage />} />
            <Route path="/cookie-policy" element={<LegalPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <QuoteDialog />
          <WhatsAppFab />
          <CookieBanner />
          <Toaster position="top-right" richColors closeButton />
        </QuoteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
